<template>
    <div class="layout-header">
        <div class="header--logo-console">
            <div class="header-left">
                <div :class="isUpdatePasswordPage ? 'click' : ''" class="logo-box" @click="goToPage">
                    <img :src="userStore.theme.systemLogo || Tenant.getInstance().theme.publicHeaderLogo" alt="" class="logo" />
                    <div v-if="companyName.includes('http')" class="company-name">
                        <img :src="companyName" alt="" />
                    </div>
                    <div v-else class="company-name">{{ companyName }}</div>
                </div>
                <div class="company-tag">客户端</div>
            </div>
        </div>
        <div class="right">
            <HistoryRoute />
            <ElBadge :show-zero="false" :value="allUnreadMsgNum || 0" class="msg" @click="toUserMessage">
                <i class="iconfont icon-xiaoxizhongxin"></i>
            </ElBadge>
            <TaskCenter />
            <div class="flex user-head">
                <User />
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed, onBeforeUnmount, onMounted } from "vue";
import { ElBadge } from "element-plus";
import User from "./components/user.vue";
import { useRoute, useRouter } from "vue-router";
import TaskCenter from "./components/taskCenter/index.vue";
import HistoryRoute from "./components/historyRoute/index.vue";
import Tenant from "@/function/tenant";
import { userMessageService } from "@/api/userMessage";
import { useUserStore } from "@/stores/user";

const route = useRoute();
const router = useRouter();
const userStore = useUserStore();
const token = computed(() => userStore.token);
const allUnreadMsgNum = computed(() => {
    return userStore.allUnreadMsgNum;
});
const companyName = computed(() => userStore.theme.systemName || Tenant.getInstance().theme.systemName);

// 获取未读消息数量
const getUnReadMsgNum = async () => {
    if (token.value) {
        const res = await userMessageService.getMsgNum();
        const allUnreadMsgNum = res.allType;
        userStore.setAllUnreadMsgNum(allUnreadMsgNum);
    }
};

// 跳转消息通知页面
const toUserMessage = () => {
    router.push({ name: "UserMessage" });
};

const isUpdatePasswordPage = computed(() => {
    return route.name === "UpdatePassword";
});

const goToPage = () => {
    // 判断是否是修改密码页面,该页面点击logo需做跳转
    if (isUpdatePasswordPage.value) {
        router.push({ name: "MyTaskIndex" });
    }
};

onMounted(() => {
    getUnReadMsgNum();
    const intervalId = setInterval(getUnReadMsgNum, 30000); // 每隔30秒执行一次

    // 清理定时器
    onBeforeUnmount(() => {
        clearInterval(intervalId);
    });
});
</script>

<style lang="scss" scoped>
.layout-header {
    box-sizing: border-box;
    width: 100vw;
    height: var(--zh-layout-header);
    background: var(--zh-layout-header-bg-color);
    border-bottom: 1px solid #00508e26;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .header--logo-console {
        display: flex;
        align-items: center;
        gap: 32px;
        height: 100%;
        padding: 0 16px;
    }

    .header-left {
        display: flex;
        align-items: center;
        color: #000000;
        .click {
            cursor: pointer;
        }
        .logo-box {
            display: flex;
            align-items: center;

            .logo {
                height: 36px;
            }
        }
        .company-name {
            color: #000000;
            font-size: 16px;
            font-weight: 500;
            line-height: 16px;
            margin-left: 12px;
            img {
                width: 103px;
            }
        }
        .company-tag {
            margin-left: 12px;
            padding: 6px 8px;
            justify-content: center;
            align-items: center;
            border-radius: 6px;
            background: #e4f2ff;
            color: $primary-color;
            font-size: 12px;
            font-weight: 400;
            line-height: 12px;
        }
    }
}

.right {
    display: flex;
    flex-flow: nowrap row;
    height: 100%;
    :deep(.history-route) {
        margin-right: 12px;
    }
    .user-head {
        gap: 20px;
        height: 100%;
        padding: 0 32px;
    }
    .msg {
        cursor: pointer;
        display: flex;
        align-items: center;
        margin-right: 30px;
        :deep(.el-badge__content) {
            top: 18px;
            height: 12px;
            padding: 0 4px;
            font-size: 8px;
            line-height: 8px;
            border: none !important;
        }
        :deep(.el-badge__content--danger) {
            background-color: #f32f31;
            color: white;
        }
    }
    .iconfont {
        font-size: 20px;
        cursor: pointer;
        color: #2143fc;
    }
}
</style>
